import { useSearchParams } from 'react-router-dom';

import { useAuthUser } from 'auth/hooks';
import { SearchListType } from 'core/components';
import { SearchParts } from 'parts/components';

export const PartList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { user } = useAuthUser();

  const onSearchQuery = (query?: string) => {
    if (!query) {
      setSearchParams([]);

      return;
    }
    setSearchParams({ query });
  };

  return (
    <SearchParts
      defaultQuery={searchParams.get('query')}
      partSearchPayload={{
        alternateVersionEnabled: user?.alternateVersionEnabled ? 1 : 0,
      }}
      onSearchQuery={onSearchQuery}
      type={SearchListType.FULL}
      isAlternateVersionEnabled={user?.alternateVersionEnabled}
    />
  );
};
